import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  @Input() progress: number;
  @Input() backgroundColor: string;
  @Input() progressTitle: string;
  @Input() progressEstimatedTime: string;
}
